export default {
    resizableSides: [],

    mobileConversionConfig: {
        preserveAspectRatio: false
    }
}
